import { IconType } from '.';

export const LocationMarker = ({ height, width, className }: IconType) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20.431 27.241" className={className}>
    <path
      id="LocationMarker"
      d="M9.165,26.691C1.435,15.484,0,14.334,0,10.215a10.215,10.215,0,1,1,20.431,0c0,4.119-1.435,5.269-9.165,16.476a1.277,1.277,0,0,1-2.1,0Zm1.05-12.219a4.256,4.256,0,1,0-4.256-4.256A4.256,4.256,0,0,0,10.215,14.472Z"
      fill="#48494a"
    />
  </svg>
);

export default LocationMarker;
